import { Helmet } from 'react-helmet-async';

/**
 * Lightweight SEO head helper. Feeds React Helmet Async so SSR pre-rendering
 * or crawlers that execute JS can pick up the metadata. Not a substitute for
 * true SSR — but a real improvement over nothing.
 */
export default function SEOHead({ title, description, path, image, type = 'website' }) {
    const fullTitle = title ? `${title} · BestNeighbourhoods.ca` : 'BestNeighbourhoods.ca — Southern Ontario Neighbourhood Intelligence';
    const canonical = path ? `https://bestneighbourhoods.ca${path}` : undefined;
    const img = image || 'https://bestneighbourhoods.ca/og-default.jpg';
    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {canonical && <link rel="canonical" href={canonical} />}
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:type" content={type} />
            {canonical && <meta property="og:url" content={canonical} />}
            <meta property="og:image" content={img} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={img} />
        </Helmet>
    );
}
